import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
// import DatePicker from "react-datepicker";
import { IoMdDownload, IoIosArrowBack, IoIosClose } from "react-icons/io"
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const OctapharmaAdminFeesSourceDataMonthly = () => {
    // const [startDate, setStartDate] = useState(new Date());
    // const [endDate, setEndDate] = useState(new Date());
    const fileName = 'Octapharma Admin Fees Source Data Monthly';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const userData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const [AdminFee, setAdminFee] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);
    // excel  headers
    const excelColumns = [
        {
            Header: "Distributor Name",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
    
        },
        {
            Header: "Distribution Location (state abbreviation)",
            accessor: "DistributionLocationState",
            filter: "DistributionLocationState",
            sortType: "basic",
            
        },
        {
            Header: "Report Date",
            accessor: "ReportDate",
            filter: "ReportDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            },
          
        },
        {
            Header: "Debit Memo#",
            accessor: "DebitMemoNum",
            filter: "DebitMemoNum",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - CB Cust ID#",
            accessor: "CustID",
            filter: "CustID",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - CB Cust ID#",
            accessor: "OctapharmavalidatedCBCustID",
            filter: "OctapharmavalidatedCBCustID",
            sortType: "basic",
            width: 350,
            
        },
        {
            Header: "CB Cust GPO or HRSA ID# (when applicable)",
            accessor: "CustGPOORHRSAID",
            filter: "CustGPOORHRSAID",
            sortType: "basic",
            width: 180,
            
        },
        {
            Header: "Submitted - CB Cust Name",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
            width: 350,
            
        },
        {
            Header: "Octapharma validated - CB Cust Name",
            accessor: "OctapharmavalidatedCBCustName",
            filter: "OctapharmavalidatedCBCustName",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - CB Cust Address",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
            width: 250,
            
        },
        {
            Header: "Octapharma validated - CB Cust Address",
            accessor: "OctapharmavalidatedCBCustAddress",
            filter: "OctapharmavalidatedCBCustAddress",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - CB Cust City",
            accessor: "CustCity",
            filter: "CustCity",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - CB Cust City",
            accessor: "OctapharmavalidatedCBCustCity",
            filter: "OctapharmavalidatedCBCustCity",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - CB Cust State",
            accessor: "CustState",
            filter: "CustState",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - CB Cust State",
            accessor: "OctapharmavalidatedCBCustState",
            filter: "OctapharmavalidatedCBCustState",
            sortType: "basic",
            width: 300,
            
        },
        {
            Header: "Submitted - CB Cust Zip",
            accessor: "CustZip",
            filter: "CustZip",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - CB Cust Zip",
            accessor: "OctapharmavalidatedCBCustZip",
            filter: "OctapharmavalidatedCBCustZip",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - CB Customer's Invoice#",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
            
        },
        {
            Header: "Submitted CB Customer's Invoice Date",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            
        },
        {
            Header: "Submitted Contract Reference#",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - Contract Reference#",
            accessor: "OctapharmavalidatedContractReference",
            filter: "OctapharmavalidatedContractReference",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - Product NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - Product NDC-11",
            accessor: "OctapharmavalidatedProductNDC",
            filter: "OctapharmavalidatedProductNDC",
            sortType: "basic",
            
        },
        {
            Header: "Product Description (Octapharma validated)",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
            width: 300,
            
        },
        {
            Header: "Sale Qty",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
            
        },
        {
            Header: "Sale Qty UOM",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - Dosage / Units",
            accessor: "DosageORUnits",
            filter: "DosageORUnits",
            sortType: "basic",
            
        },
        // ==============================
        {
            Header: "Octapharma validated - Dosage / Units",
            accessor: "OctapharmavalidatedDosageORUnits",
            filter: "OctapharmavalidatedDosageORUnits",
            sortType: "basic",
            
        },
        {
            Header: "Dosage / Units UOM",
            accessor: "DosageORUnitsUOM",
            filter: "DosageORUnitsUOM",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - Total IUs/EUs/Grams",
            accessor: "Totalcount",
            filter: "Totalcount",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - Total IUs/EUs/Grams",
            accessor: "OctapharmavalidatedTotal",
            filter: "OctapharmavalidatedTotal",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - DAC per IU/EU/Gram",
            accessor: "DACperIUOREUORGram",
            filter: "DACperIUOREUORGram",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - DAC (priced per IU/EU/Gram)",
            accessor: "OctapharmavalidatedDACperIUOREUORGram",
            filter: "OctapharmavalidatedDACperIUOREUORGram",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - Contract price per IU/EU/Gram",
            accessor: "ContractpriceperIUOREUORGram",
            filter: "ContractpriceperIUOREUORGram",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma validated - Contract price per IU/EU/Gram",
            accessor: "OctapharmaValidatedContractpriceperIU",
            filter: "OctapharmaValidatedContractpriceperIU",
            sortType: "basic",
            
        },
        {
            Header: "Submitted - Requested Extended Amount",
            accessor: "RequestedExtendedAmount",
            filter: "RequestedExtendedAmount",
            sortType: "basic",
            
        },

        // ===========================  no v
        {
            Header: "Octapharma validated - Extended Amount (issued/deducted)",
            accessor: "ADMFees30",
            filter: "ADMFees30",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma note: Reason for change, questions to distributors, or requests to correct data",
            accessor: "OctapharmanNote",
            filter: "OctapharmanNote",
            sortType: "basic",
            
        },

        {
            Header: "Octapharma note: Acceptance reasoning notes",
            accessor: "OctapharmanAcceptanceReasoningNotes",
            filter: "OctapharmanAcceptanceReasoningNotes",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma notes: Reason for rejection, or requests for further information from distributor",
            accessor: "OctapharmaNoteReasonForRejection",
            filter: "OctapharmaNoteReasonForRejection",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma - Payment Date (check, wired, or deducted on dates)",
            accessor: "OctapharmaPaymentDate",
            filter: "OctapharmaPaymentDate",
            sortType: "basic",
            
        },

        {
            Header: "Octapharma check#, Wire Transfer#, or Deduction transaction ref#",
            accessor: "OctapharmaTransactionRef",
            filter: "OctapharmaTransactionRef",
            sortType: "basic",
            
        },
        {
            Header: "Month/Year Payment processed at Octapharma",
            accessor: "MonthORYearPaymentProcessed",
            filter: "MonthORYearPaymentProcessed",
            sortType: "basic",
            
        },
        {
            Header: "Distributor Notification name (for chargeback use)",
            accessor: "DistributorNotificationNameForChargebackUse",
            filter: "DistributorNotificationNameForChargebackUse",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma - EDI pay/no pay line indicator:  P - Process R - Rejected PA - Pay accrual amount D - Deducted",
            accessor: "OctapharmaEDIPay",
            filter: "OctapharmaEDIPay",
            sortType: "basic",
            
        },
        {
            Header: "Octapharma - EDI Source Indicator",
            accessor: "OctapharmaEDISourceIndicator",
            filter: "OctapharmaEDISourceIndicator",
            sortType: "basic",
            
        },
        // ========================
        {
            Header: "CIBD Extended Amount",
            accessor: "CIBDExtendedAmount",
            filter: "CIBDExtendedAmount",
            sortType: "basic",
            
        },
        {
            Header: "4% Admin Fee",
            accessor: "AdminFee",
            filter: "AdminFee",
            sortType: "basic",
            
        }

    ];

    useEffect(() => {
        getAdminFees();
    }, []);

    async function getAdminFees() {
        setLoading(true);
        await _HttpServices
            .getData(`Api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}`)
            .then((data) => {
                const AdminFeeResult = data.data;
                if (AdminFeeResult.length > 0) {  
                    AdminFeeResult.map((res) => {
                        res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');
                        res.ReportDate = moment(res.ReportDate).format('MM/DD/YYYY');
                        res.AdminFee = res.AdminFee == null ? "$0.00" : "$" + (res.AdminFee * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.CIBDExtendedAmount = res.CIBDExtendedAmount == null ? "$0.00" : "$" + (res.CIBDExtendedAmount * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.RequestedExtendedAmount = res.RequestedExtendedAmount == null ? "$0.00" : "$" + (res.RequestedExtendedAmount * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.ContractpriceperIUOREUORGram = res.ContractpriceperIUOREUORGram == null ? "$0.00" : "$" + (res.ContractpriceperIUOREUORGram * 1).toFixed(2);
                        res.DACperIUOREUORGram = res.DACperIUOREUORGram == null ? "$0.00" : "$" + (res.DACperIUOREUORGram * 1).toFixed(2);
                        res.Totalcount = res.Totalcount == null ? "0.00" : (res.Totalcount * 1).toFixed(2);
                        res.DosageORUnits = res.DosageORUnits == null ? "0.00" : (res.DosageORUnits * 1).toFixed(2);
                        //   res.CIBDExtendedAmount = res.CIBDExtendedAmount == null ? "$0.00" :"$"+ (res.CIBDExtendedAmount * 1).toFixed(2);   
                    })
                }
                setAdminFee(AdminFeeResult)
                setLoading(false);

            })
            .catch((e) => {
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
                setLoading(false);
            });
    }
    const EditRecords = () =>{
        localStorage.setItem("AdminFee",JSON.stringify(AdminFee));
        history.push("/OctapharmaAdminFeesEdit")
    }

    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Octapharma Admin Fees Source Data Monthly</h2>
                {loading ? <Loader /> : null}
                <div>
                {AdminFee.length > 0 &&userData.RoleID === 1 &&
                 (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                    
                <Button type="submit" className="ml-2" onClick={() => getExcel(excelColumns, AdminFee, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
</div>
            </div>
            {/* Toaster */}
            {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Octapharma Admin Fees Source Data Monthly.</p> :
                                <Fragment>
                                    {AdminFee.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={AdminFee} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="text-right mt-2">
                    <Button
                        variant="danger"
                        type="button"
                        className="ml-3"
                        onClick={() => history.goBack()}
                    >
                        {/* <IoIosArrowBack className="icon btn-icon back-icon" />
                        Back */}
                         <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
                </Col>
            </Row>
            <Footer />
        </section>
    );
}

export default OctapharmaAdminFeesSourceDataMonthly